import type { ReactNode } from 'react'
import './heroHeaderCard.css'

export type HeroHeaderCardProps = {
  eyebrow: ReactNode
  title: ReactNode
  rightSlot?: ReactNode
  children?: ReactNode
  className?: string
}

/** Shared mobile hero chrome; content remains owned by each destination. */
export const HeroHeaderCard = ({ eyebrow, title, rightSlot, children, className }: HeroHeaderCardProps) => (
  <header className={['heroHeaderCard', className ?? ''].filter(Boolean).join(' ')} data-testid="hero-header-card">
    <span className="heroHeaderCard__accent" aria-hidden="true" data-testid="hero-header-card-accent" />
    <div className="heroHeaderCard__main">
      <span className="heroHeaderCard__eyebrow">{eyebrow}</span>
      <h2 className="heroHeaderCard__title">{title}</h2>
      {children ? <div className="heroHeaderCard__content">{children}</div> : null}
    </div>
    {rightSlot ? <div className="heroHeaderCard__right">{rightSlot}</div> : null}
  </header>
)
